import React, { useEffect, useState } from 'react'
import './index.css';
import { Button, Modal, } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
export default function PopUpModal(props) {
    const { MSGTitle, MSGContext, MSGBtn, showMSG, setShowMSG } = props
    const [backLastPage, setBackLastPage] = useState('none')
    var { Link, onClick } = props;
    const navigate = useNavigate();

    useEffect(() => {
        if (Link != "") {
            setBackLastPage("")
        }
    }, [])
    function toVisitor(Link) {
        var backLastPage = "/" + Link;
        console.log(backLastPage)
        navigate(backLastPage);
    }
    return (
        <Modal
            show={showMSG}
            // onHide={() => setShowMSG(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
            rounded
            className="Pop_Modal" >


            <Modal.Body className="ErrorModal_Modalbc">

                <div className='MSGDiv  text-center' >

                    <p><b>  {MSGTitle}</b></p>
                    {MSGContext}
                    <hr />
                    <div className='pop_btn '>
                        <input type="button" className='Btn_Back' value={MSGBtn} onClick={() => {
                            if (onClick) {
                                onClick();
                            } else {
                                toVisitor(Link)
                            }
                        }}></input>
                    </div>
                </div>

            </Modal.Body>

        </Modal>
    )
}